import React from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Image, Label } from 'semantic-ui-react';
import styles from './Playlist.scss';

const PlaylistPreview = ({
  following,
  openPlaylist,
  playlist,
  style
}) => {
  const numSongs = playlist.num_songs;
  return (
    <div style={{ paddingBottom: '1em' }}>
      <div
        onClick={() => {
          if (openPlaylist) openPlaylist(playlist.id);
        }}
        key={playlist.id}
        className='ui card fluid link'
        style={style}
      >
        <Card.Content>
          <div style={{ display: 'flex' }}>
            <div className={styles.songThumbnail}>
              {!playlist.thumbnail && <Icon name='music' />}
              {playlist.thumbnail && <Image src={playlist.thumbnail.url} />}
            </div>
            <div className={[styles.songDetails, styles.truncate].join(' ')}>
              <strong>
                {playlist.title}
              </strong>
              <br />
              <span className={styles.muted}>
                {playlist.description}
              </span>
              {following &&
                <Label style={{ marginTop: '0.5em' }}>Following</Label>}
            </div>
            <div>
              {numSongs} {`song${numSongs !== 1 ? 's' : ''}`}
            </div>
          </div>
        </Card.Content>
      </div>
    </div>
  );
};

PlaylistPreview.propTypes = {
  following: PropTypes.bool,
  openPlaylist: PropTypes.func,
  playlist: PropTypes.object.isRequired,
  style: PropTypes.object
};

export default PlaylistPreview;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Preview.js